"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReportDefinitionsLogic = void 0;
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const react_dom_1 = require("react-dom");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const snackbar_context_1 = require("../../../composite/snackbar/snackbar-context");
const snackbar_types_1 = require("../../../composite/snackbar/snackbar-types");
const reporting_context_1 = require("../reporting-context");
function useReportDefinitionsLogic() {
    const intl = react_intl_1.useIntl();
    const { loadDefinitions } = react_1.useContext(reporting_context_1.ReportingContext);
    const { showSnackbar } = react_1.useContext(snackbar_context_1.SnackbarContext);
    const [loading, setLoading] = react_1.useState(false);
    const [definitions, setDefinitions] = react_1.useState([]);
    const load = event_callback_hook_1.useEventCallback(async () => {
        try {
            setLoading(true);
            const definitions = await loadDefinitions();
            react_dom_1.unstable_batchedUpdates(() => {
                setDefinitions(definitions);
                setLoading(false);
            });
        }
        catch (err) {
            setLoading(false);
            if (err.name !== 'AbortError') {
                const message = intl.formatMessage({
                    id: 'EAS_REPORTING_DEFINITIONS_ERROR_LOADING',
                    defaultMessage: 'Chyba načtení reportů',
                });
                showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
            }
            return undefined;
        }
    });
    react_1.useEffect(() => {
        load();
    }, [load]);
    return {
        definitions,
        loading,
    };
}
exports.useReportDefinitionsLogic = useReportDefinitionsLogic;
//# sourceMappingURL=definitions-hook.js.map